__turbopack_context__.v({
  "arrow": "RelatedStudies-module__ZWV3va__arrow",
  "cardAnchor": "RelatedStudies-module__ZWV3va__cardAnchor",
  "cardLink": "RelatedStudies-module__ZWV3va__cardLink",
  "container": "RelatedStudies-module__ZWV3va__container",
  "dateText": "RelatedStudies-module__ZWV3va__dateText",
  "eyebrow": "RelatedStudies-module__ZWV3va__eyebrow",
  "foot": "RelatedStudies-module__ZWV3va__foot",
  "grid": "RelatedStudies-module__ZWV3va__grid",
  "header": "RelatedStudies-module__ZWV3va__header",
  "heading": "RelatedStudies-module__ZWV3va__heading",
  "pill": "RelatedStudies-module__ZWV3va__pill",
  "readLabel": "RelatedStudies-module__ZWV3va__readLabel",
  "section": "RelatedStudies-module__ZWV3va__section",
  "title": "RelatedStudies-module__ZWV3va__title",
  "top": "RelatedStudies-module__ZWV3va__top",
});
